<template>
  <div class="row mb-2">
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Ustvarjen od"
      v-model="modelValue.createdFrom"  />
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Ustvarjen do"
      v-model="modelValue.createdTo"  />
    <div class="col-md-2">
      <a href="#" class="me-2" @click.prevent="setDateRange('created', 0)">Danes</a>
      <a href="#" class="me-2" @click.prevent="setDateRange('created', -1)">⏪</a>
      <a href="#" @click.prevent="clearRange('created')">✕</a>
    </div>
  </div>
  <div class="row mb-2" v-show="modelValue.status.includes('Completed')">
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Končan od"
      v-model="modelValue.completedFrom"  />
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Končan do"
      v-model="modelValue.completedTo"  />
    <div class="col-md-2">
      <a href="#" class="me-2" @click.prevent="setDateRange('completed', 0)">Danes</a>
      <a href="#" class="me-2" @click.prevent="setDateRange('completed', -1)">⏪</a>
      <a href="#" @click.prevent="clearRange('completed')">✕</a>
    </div>
  </div>
  <div class="row mb-2" v-show="modelValue.status.includes('Finalized')">
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Zaključen od"
      v-model="modelValue.finalizedFrom"  />
    <DateTimeInput class="col-md-5" colClassLeft="col-sm-4" colClassRight="col-sm-8"
      label-text="Zaključen do"
      v-model="modelValue.finalizedTo"  />
    <div class="col-md-2">
      <a href="#" class="me-2" @click.prevent="setDateRange('finalized', 0)">Danes</a>
      <a href="#" class="me-2" @click.prevent="setDateRange('finalized', -1)">⏪</a>
      <a href="#" @click.prevent="clearRange('finalized')">✕</a>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs"

defineOptions({ name: "DatetimeFilterSet" })

const props = defineProps({
    modelValue: { type: Object },
  })

const emit = defineEmits(["update:modelValue"])

const setDateRange = (field, offset) => {
  const day = dayjs().add(offset, "day")
  props.modelValue[`${field}From`] = day.startOf("day").format("YYYY-MM-DDTHH:mm")
  props.modelValue[`${field}To`] = day.endOf("day").format("YYYY-MM-DDTHH:mm")
}
const clearRange = (field) => {
  props.modelValue[`${field}From`] = ""
  props.modelValue[`${field}To`] = ""
}
</script>
